<template>
  <div class="vision-abnormal-page">
    <windowSocket class="socket-box" ref="socketRef" @message="onMessage" @open="onConnected">
      <grid ref="gridRef" :colHeight="'700px'">
        <template slot-scope="slot">
          <Card class="head-item-box">
            <pointItem :robot="slot.data" />
          </Card>
        </template>
      </grid>
    </windowSocket>
  </div>
</template>
<script>
import windowSocket from '_c/windowSocket/index.vue';
import grid from '_c/grid/index.vue';
import pointItem from './subunits/pointItem.vue';
import api from "@/api";
import {checkAndFetchMenuList } from '@/libs/util';
import langMap from '@/utils/language';
import { mapState } from 'vuex';
let gridRef = null;

const copy = (arr) => JSON.parse(JSON.stringify(arr));
function prodRobotArray(arr, d = {}) {
  const _ids = arr || [];
  const data = _ids.map(v => {
    return { robotId: v, ...copy(d) };
  });
  return data;
}

function getIndexById(arr, id) {
  let _ix = -1;
  arr.some((v, i) => {
    if (v.robotId === id) { _ix = i; return true; }
  });
  return _ix;
}
/*TODO:调试时将数组置空（属性名需要保留）*/
function initData(language) {
  return {
    isOffline: true,
    tipContent: langMap.robotIsOffline[language]
  }
}
export default {
  components: { windowSocket, grid, pointItem },
  data() {
    return {
      showImg: false,
      dataList: []
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
  },
  methods: {
    getRobots() {
      return api.getData("notice-server/usr/robot/list", this).then(res => {
        if (res.state === 1) {
          this.dataList = prodRobotArray(res.data, initData(this.lang));

          gridRef && gridRef.refreshList(this.dataList);
        }
      });
    },
    onMessage(data) {
      let _dataList = copy(this.dataList);
      const _id = data.robotId;
      let _ix = getIndexById(_dataList, _id);

      switch (data.type) {
        case 'robot_ids':
          const _idarr = data.data || []
          _dataList = prodRobotArray(_idarr, initData(this.lang));
          break;
        case 'situation':
          let _cloudData = data.data || {};
          _cloudData.robotId = _id;
          _dataList[_ix] = _cloudData;
          break;
        case 'offline:':
          _dataList[_ix].tipContent = langMap.robotIsOffline[this.lang];
          this.$nextTick(() => gridRef.showTip(_ix, 'offline'));
          break;
        case 'online:':
          _dataList[_ix].tipContent = langMap.robotIsOnline[this.lang];
          this.$nextTick(() => gridRef.showTip(_ix,'online'));
          break;
        default:
          //console.warn('未知的类型--', data);
      }
      // 刷新列表
      this.dataList = _dataList;
      //console.log('[dataList>>]', data.type,this.dataList,_ix);
      this.$nextTick(() => { gridRef && gridRef.refreshList(this.dataList); });
    },
    onConnected() {
      const userStore = this.$store.state.user.userInfo;
      this.$refs.socketRef.send({ type: 'online', robotId: '', data: `${userStore.userId}_cloud` });
    }
  },
  async mounted() {
    gridRef = this.$refs.gridRef;
    await this.getRobots();
    this.$refs.socketRef.init();
    checkAndFetchMenuList(this.$store);
  }
}
</script>
<style scoped lang="less">
.vision-abnormal-page {
  height: 100%;
}

.head-item-box {
  height: 99%;
  width: 99%;

  /deep/.ivu-card-body {
    height: 100%;
  }


}
</style>
